import React, { useEffect, useState, useRef, useContext } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import $ from 'jquery';
import { CheckSession, FormatCurrency, GetCoockie, GetShoppingCart, KImageURL, DefaultImage } from "../GlobalScript";
import { ShoppingCartContext } from '../dealer/ShoppingCartContext';
import Cookies from 'js-cookie';
import Select from 'react-select'
import ReactPaginate from 'react-paginate';
import PulseLoader from "react-spinners/PulseLoader";
import Container from 'react-bootstrap/Container';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Table from 'react-bootstrap/Table';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import InputGroup from 'react-bootstrap/InputGroup';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import FooterDealer from '../FooterDealer';
//import useLocalStorage from "use-local-storage";

export default function InventoryList() {

    const navigate = useNavigate();
    const [pageResults, setPageResults] = useState(10);
    const [tempPage, setTempPage] = useState(10);
    const [resultsLength, setResultsLength] = useState(0);
    const [Items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [keyword, setKeyword] = useState('');
    const [searchType, setSearchType] = useState('1');
    const [itemOffset, setItemOffset] = useState(0);
    const endOffset = itemOffset + pageResults;
    const pageCount = Math.ceil(Items.length / pageResults);
    const currentItems = Items.slice(itemOffset, endOffset);
    const [CategoryList, setCategoryList] = useState(null);
    const [Category, setCategory] = useState(null);
    const [vehicle, setVehicle] = useState('');
    const [model, setModel] = useState('');
    const [year, setYear] = useState('');
    const [ModelList, setModelList] = useState(null);
    const [YearList, setYearList] = useState(null);
    const [VehicleList, setVehicleList] = useState(null);
    const [pop, setPop] = useState(false);

    useEffect(() => {
        document.title = 'K-Dealer - Inventory Admin';
    });

    const [searchSession, setSearchSession] = useState(() => {
        const data = localStorage.getItem('inventorySrch');
        return data ? JSON.parse(data) : null;
    });

    const [preLoadSession, setPreLoadSession] = useState(false);

    const handlePop = () => setPop(true);
    const handleClosePop = () => setPop(false);

    const goItemEdit = async (id) => {
        navigate('/catalog/itemedit', { state: { id: id } });
    }

    useEffect(() => {
        if (searchSession) {
            setKeyword(searchSession.keyword);
            setCategory(searchSession.category && searchSession.category.length > 0 ? searchSession.category : null);
            setPreLoadSession(true);
        }
    }, [searchSession])
   
    useEffect(() => {
        if (!VehicleList) {
            LoadVehicleList();
        }
    }, [VehicleList]);

    useEffect(() => {
        if (vehicle) {
            LoadYearList();
        } else {
            setYearList(null);
        }
        setModelList(null);
        setYear('');
        setModel('');
    }, [vehicle]);

    useEffect(() => {
        if (year) {
            LoadModelList();
            if (preLoadSession) {
                setModel(searchSession && searchSession.model && searchSession.model !== '' ? searchSession.model : null);
                handleSearchClick();
            }
            setPreLoadSession(false);
        } else {
            setModelList(null);
        }
        setModel('');
    }, [year]);

    const LoadVehicleList = async () => {
        try {
            CheckSession();
            handlePop();
            const response = await fetch("catalog/GetVehicleList");
            if (response.status !== 200) {
                return;
            }
            const lst = await response.json();
            setVehicleList(lst);
        } catch (e) {
            console.log(e);
        } finally {
            handleClosePop();
        }
    }

    useEffect(() => {
        if (!CategoryList) {
            LoadCategoryList();
        }
    }, [CategoryList]);

    const ResetSearch = async () => {
        setKeyword('');
        setYear('');
        setVehicle('');
        setCategory(null);
        setLoading(true);
        localStorage.setItem('inventorySrch', null);
    }

    const LoadCategoryList = async () => {
        try {
            CheckSession();
            handlePop();
            const response = await fetch("inventory/GetCategoryList");
            if (response.status !== 200) {
                return;
            }
            const lst = await response.json();
            setCategoryList(lst);
        } catch (e) {
            console.log(e);
        } finally {
            handleClosePop();
        }
    }

    const LoadYearList = async () => {
        try {
            CheckSession();
            handlePop();
            const response = await fetch('catalog/GetYearList/' + vehicle);
            if (response.status !== 200) {
                return;
            }
            const lst = await response.json();
            setYearList(lst);
        } catch (e) {
            console.log(e);
        } finally {
            handleClosePop();
        }
    }

    const LoadModelList = async () => {
        try {
            if (!year || !vehicle) {
                return;
            }
            handlePop();
            const data = [vehicle, year];
            CheckSession();
            const rqst = {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json'
                },
                body: JSON.stringify(data)
            };
            const response = await fetch('catalog/GetModelList/', rqst);
            if (response.status !== 200) {
                return;
            }
            const lst = await response.json();
            setModelList(lst);
        } catch (e) {
            console.log(e);
        } finally {
            handleClosePop();
        }
    }

    const GetItems = async (orderby, inc) => {
        try {
            CheckSession();
            if ((!keyword || keyword.trim() === '') && (!year && !model) && !CategoryList) {
                handleClosePop();
                return;
            }
            const data = {
                keyword: keyword.trim(),
                year: year ? year : [],
                orderBy: orderby,
                inc: inc,
                model: model ? model : [],
                category: Category?Category.map(obj => obj.value): [],
            }
            const serchData = {
                keyword: keyword.trim(),
                year: year,
                model: model,
                category: Category,
            }
            localStorage.setItem('inventorySrch', JSON.stringify(serchData));
            if (data.keyword === '' && (data.year === '' || data.model === '') && data.category.length === 0) {
                handleClosePop();
                return;
            }
            const requestOptions = {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json'
                },
                body: JSON.stringify(data)
            };
            const response = await fetch("inventory/GetItems", requestOptions);
            if (response.status !== 200) {
                setItems([]);
                handleClosePop();
                return;
            }
            const res = await response.json();
            setItems(res);
            handleClosePop();
            setResultsLength(res.length);
            console.log(res)
        } catch (e) {
            handleClosePop();
            console.log(e);
            return;
        }
    }

    const handleChange = (event) => {
        const { name, value } = event.target;
        if (name === 'keyword') {
            setKeyword(value);
        } else if (name === 'category') {
            setCategoryList(value);
        } else if (name === 'searchMethod') {
            setSearchType(value);
        } else if (name === 'vehicle') {
            setVehicle(value);
        } else if (name === 'model') {
            setModel(value);
        } else if (name === 'year') {
            setYear(value);
        } else if (name === 'tempPage') {
            setTempPage(value);
        }
    }

    const handleSearchClick = async () => {
        try {
            handlePop();
            GetItems('', true);
        } catch (e) {
            handleClosePop();
            console.log(e);
        }
    };

    const handlePageClick = (event) => {
        const newOffset = (event.selected * pageResults) % Items.length;
        console.log(
            `User requested page number ${event.selected}, which is offset ${newOffset}`
        );
        setItemOffset(newOffset);
    };

    const changePageResults = () => {
        if (tempPage && tempPage > 0 && tempPage < 1000) {
            setPageResults(tempPage);
        }
    }

    const handleChangeCategory = (selected) => {
        setCategory(selected);
    };
    const handleChangeModel = (selected) => {
        setModel(selected);
    };
    const handleChangeYear = (selected) => {
        setYear(selected);
    };

    return (
        <>
            <Container className="checkout-container main-container dealer-section min-height-spacing-lg">

                <Row className="help-title-row checkout-title-row">
                    <Col className="help-center-title checkout-title">
                        <h1 className="heading help-heading">Inventory Admin</h1>
                    </Col>
                    <Col className="checkout-title-under"></Col>
                </Row>

                <Row>
                    <Col sm={12}>
                        <Card>
                            <Card.Body>
                                <Row className="mb-4">
                                    <Col className="col-fit-width">
                                        <h4 className="heading bold">SEARCH BY:</h4>
                                    </Col>

                                    <Col>
                                        <div className="inline-radio-group">
                                            <Form.Check
                                                inline
                                                label="Keyword"
                                                name="searchMethod"
                                                type='radio'
                                                id='inline-radio-1'
                                                defaultChecked
                                                value={'1'}
                                                onChange={handleChange}
                                            />
                                            <Form.Check
                                                inline
                                                label="Model/Year"
                                                name="searchMethod"
                                                type='radio'
                                                id='inline-radio-2'
                                                value={'2'}
                                                onChange={handleChange}
                                            />
                                            <Form.Check
                                                inline
                                                label="Category"
                                                name="searchMethod"
                                                type='radio'
                                                id='inline-radio-3'
                                                value={'3'}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </Col>
                                </Row>

                                <Row>
                                    {searchType === '1' ?    
                                        <Col sm={6}>
                                            <FloatingLabel label="Keyword" className="mb-4">
                                                <Form.Control id="keyword" type="text" placeholder="Keyword" value={keyword} className={'form-control'} onChange={handleChange} name="keyword" />
                                            </FloatingLabel>
                                        </Col>
                                    : searchType === '2' ?
                                        <>  
                                            <Col sm={2}>
                                                <Form.Select aria-label="Vehicle" value={vehicle} onChange={handleChange} name="vehicle" className="mt-2">
                                                    <option value={''}>Select a vehicle</option>
                                                    {VehicleList && VehicleList.map(op => (
                                                        <option key={op.value} value={op.value}>{op.label}</option>
                                                    ))}
                                                </Form.Select>
                                            </Col>

                                            <Col sm={2}>
                                                <Form.Select aria-label="Year" value={year} onChange={handleChange} name="year" className="mt-2">
                                                    <option value={''}>Year</option>
                                                    {YearList && YearList.map(op => (
                                                        <option key={op.value} value={op.value}>{op.label}</option>
                                                    ))}
                                                </Form.Select>
                                            </Col>

                                            <Col sm={2}>
                                                <Form.Select aria-label="Model" value={model} onChange={handleChange} name="model" className="mt-2">
                                                    <option value={''}>Select a model</option>
                                                    {ModelList && ModelList.map(op => (
                                                        <option key={op.value} value={op.value}>{op.label}</option>
                                                    ))}
                                                </Form.Select>
                                            </Col>
                                        </>
                                    :
                                        <Col sm={6}>
                                            {CategoryList && <Select
                                                placeholder={<div>Category</div>}
                                                isMulti
                                                options={CategoryList}
                                                value={Category}
                                                onChange={handleChangeCategory}
                                                className="mt-2"
                                            />}
                                        </Col>
                                    }
                                {/*</Row>*/}

                                    {/*<Row>*/}
                                    <Col sm={6} className="text-right">
                                        <Row>
                                            <Col className="text-right" style={{ alignSelf: 'center' }}>
                                                <p className="green-text">
                                                    <span className="clickable underline" onClick={ResetSearch}>Reset Search</span>
                                                </p>
                                            </Col>

                                            <Col className="text-center mb-3 col-fit-width">
                                                <Button variant="primary" onClick={handleSearchClick}>
                                                    <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16" role="presentation">
                                                        <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                                    </svg>
                                                    SEARCH
                                                </Button>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                {currentItems && currentItems.length > 0 ?
                    <Row className="mt-5 mb-5">
                        <Col sm={12}>
                            <Card>
                                <Card.Body>
                                    <Row className="table-legend text-center">
                                        <Col sm={12}>
                                            <div className="table-legend-section">
                                                <span className="svg-holder"><img src="../../../Images/parts.svg" alt="" className="" /> Parts</span>
                                                <span className="svg-holder"><img src="../../../Images/accessories.svg" alt="" className="" /> Accessories</span>
                                                <span className="svg-holder"><img src="../../../Images/other.svg" alt="" className="" /> Other</span>
                                            </div>
                                            <div className="table-legend-section">
                                                <span className="svg-holder"><img src="../../../Images/partially-shipped.svg" alt="" className="" /> Partially Shipped</span>
                                                <span className="svg-holder"><img src="../../../Images/shipped-active.svg" alt="" className="" /> Shipped</span>
                                                <span className="svg-holder"><img src="../../../Images/returned.svg" alt="" className="" /> Returned</span>
                                                <span className="svg-holder"><img src="../../../Images/queued.svg" alt="" className="" /> Queued</span>
                                                <span className="svg-holder"><img src="../../../Images/cancelled-inactive.svg" alt="" className="" /> Cancelled</span>
                                            </div>
                                            <div className="table-legend-section">
                                                <span className="svg-holder"><img src="../../../Images/backorder.svg" alt="" className="" /> Backorder</span>
                                            </div>
                                        </Col>
                                    </Row>

                                    <Row className="pagination-row">
                                        <Col sm={12}>
                                            <p>
                                                <span className="bold">{resultsLength > 0 && resultsLength}</span> results | View
                                                <div className="paginate-results">
                                                    <input name="tempPage" type="text" value={tempPage} onChange={handleChange} className="form-control" />
                                                    <button className="btn btn-black btn-pagenav" onClick={changePageResults}>Go</button>
                                                </div>
                                            </p>

                                            <ReactPaginate
                                                breakLabel="..."
                                                nextLabel="next >"
                                                onPageChange={handlePageClick}
                                                pageRangeDisplayed={5}
                                                pageCount={pageCount}
                                                previousLabel="< previous"
                                                renderOnZeroPageCount={null}
                                                containerClassName="table-navigation"
                                                previousLinkClassName="table-nav-link"
                                                nextLinkClassName="table-nav-link"
                                            />
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col sm={12} className="order-table">
                                            <Table hover responsive>
                                                <thead>
                                                    <tr>
                                                        <th>#</th>
                                                        <th>Image</th>
                                                        <th>Item Number</th>
                                                        <th>Item Name</th>
                                                        <th>Category</th>
                                                        <th>Model(s)</th>
                                                        <th>Year(s)</th>
                                                        <th>Status</th>
                                                        <th width="10%"></th>
                                                    </tr>
                                                </thead>
                                                <tbody>

                                                    {currentItems && currentItems.map((item, index) => (
                                                        <tr className="" key={item.refID}>
                                                            <td>{index + 1}</td>
                                                            <td className="table-img">
                                                                <img src={KImageURL(item.itemNumber, item.imgName)}
                                                                    onError={({ currentTarget }) => {
                                                                        currentTarget.onerror = null;
                                                                        currentTarget.src = DefaultImage;
                                                                    }}
                                                                    alt="Product" className="item-image"></img>
                                                            </td>
                                                            <td>{item.itemNumber}</td>
                                                            <td>{item.itemDescription}</td>
                                                            <td>{item.categoryName}</td>
                                                            <td>{item.modelMarketingNames}</td>
                                                            <td>{item.modelYear}</td>
                                                            <td></td>
                                                            <td className="table-row">
                                                                <span className="underline" onClick={() => goItemEdit(item.itemNumber)}>Edit</span>
                                                            </td>
                                                        </tr>
                                                    ))}

                                                </tbody>
                                            </Table>
                                        </Col>
                                    </Row>

                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                :
                    <Card className="m-t-sm mb-3">
                        <Card.Body>
                            <Row>
                                <Col sm={12} className="text-center">
                                    <p className="bold mt-5 mb-5 svg-carat">
                                        <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill green" viewBox="0 0 16 16" role="presentation">
                                            <path transform="rotate(-90 8 8)" d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                        </svg>
                                        Enter field(s) above to begin your search
                                    </p>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                }              

            </Container>

            <FooterDealer />

            <Modal className="loader-div" id="loader" show={pop} onHide={handleClosePop} size="lg" centered backdrop="static" keyboard={false}>
                <PulseLoader color="#66cc33" size="20px" margin="12px" />
            </Modal>
        </>
    );
}